<script lang="ts">
  export let size: number = 10;

  $: style = `--dot-loader-size:${size}px;`;
</script>

<div {style} class="dot-loader-pulse dot-loader-before mr-xs" />
<div {style} class="dot-loader-pulse mr-xs" />
<div {style} class="dot-loader-pulse dot-loader-after" />

<style lang="scss">
  // Credits: https://codepen.io/nzbin/pen/GGrXbp

  .dot-loader-pulse {
    display: inline-block;
    width: var(--dot-loader-size);
    height: var(--dot-loader-size);
    border-radius: 50%;
    background-color: var(--primary);
    color: var(--primary);
    animation: dotPulse 1.5s infinite linear;
    animation-delay: 0.25s;
    transform: scale(0);
  }

  .dot-loader-before {
    animation-delay: 0s;
  }

  .dot-loader-after {
    animation-delay: 0.5s;
  }

  @keyframes dotPulse {
    0% {
      transform: scale(0);
    }
    30% {
      transform: scale(1.2);
    }
    60%,
    100% {
      transform: scale(0);
    }
  }
</style>
